import { z } from 'zod';

export type EntityWithName = {
	id: number;
	name: string;
};

export const entityWithNameSchema: z.ZodType<EntityWithName> = z.object({
	id: z.number(),
	name: z.string(),
});
